<template>
    <el-popover trigger="hover" :placement="placement" :offset="offset" :width="width">
        <slot></slot>
        <div style="width:100%" slot="reference" class="name-wrapper cell">
            <slot name="content" v-if="$slots.content"></slot>
            <span v-else>{{ _contant }}</span>
        </div>
    </el-popover>
</template>

<script>
    import Vue, { Component } from 'C/BaseVue'
    import { formatDate, getDateDay } from 'service/utils'

    @Component({
        components: {},
        props: {
            offset : {
                type: Number,
                default: () => {
                    return 0
                }
            },
            placement: {
                type: [String],
                required: false,
                default: ()=>{
                    return 'bottom-start'
                }
            },
            width: {
                type: [String,Number],
                required: false,
                default: ()=>{
                    return '150px'
                }
            },
            item: {
                type: Object,
                required: false,
                default: ()=>{}
            },
            reference: {
                type: [String,Array],
                required: false,
                default: ()=>{
                    return ''
                }
            }
        },
        watch: {},
    })

    export default class PopoverTabs extends Vue {
        mounted(){}

        get _contant(){
            let item = this.item, reference = this.reference
            if(!item) return
            if(reference instanceof Array){
                let str = `${formatDate(new Date(item[reference[0]]),'yyyy年MM月dd日')} ${getDateDay(item[reference[0]])}
                ${item[reference[1]]}~${item[reference[2]]}`
                return str
            }else if(item[reference] && typeof item[reference] === 'object'){
                let str = `${formatDate(new Date(item[reference].classes_date),'yyyy年MM月dd日')} ${getDateDay(item[reference].classes_date)}
                ${item[reference].start_time}~${item[reference].end_time}`

                return str
            }else{
                return item[reference] || '--'
            }
        }
    }

</script>
<style lang="scss" type="text/css" scoped>
    .name-wrapper.cell{
        padding: 0
    }
</style>



// WEBPACK FOOTER //
// src/components/PopoverTabs.vue